export const DEFAULT_NB_COLUMN = 2;

export const validatorHandler = validate =>
  (!Array.isArray(validate) ? validate : (...args) => validate.reduce((acc, fn) => fn(...args) ?? acc, undefined));

/**
 * @param {import(".").FieldsConfig} fields
 * @param {number} nbColumn
 * @returns {Array<{ rowKeys: string[], children: import(".").FieldsConfig }>}
 */
export const rowColFormatter = (fields, nbColumn = DEFAULT_NB_COLUMN) =>
  fields.reduce((acc, field, index) => {
    const fieldKey = field.key ?? field.name;
    const newLine = field.newLine || index === 0 || acc[acc.length - 1]?.children.length === nbColumn;
    if (newLine) {
      acc.push({ rowKeys: [fieldKey], children: [field] });
    } else {
      acc[acc.length - 1].children.push(field);
      acc[acc.length - 1].rowKeys.push(fieldKey);
    }
    return acc;
  }, []);

/**
 * @param {import("components/configuration/dealer/Global/components/common/SimpleFieldsPanel").FieldsConfig} fields
 * @param {Object} props
 * @returns {import("components/configuration/dealer/Global/components/common/SimpleFieldsPanel").FieldsConfig}
 */
export const applyPropsToFields = (fields, props) =>
  fields.map(field => ({ ...field, componentProps: { ...field.componentProps, ...props } }));
